var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCybersecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.86,145.09H44.74V156H33.86Zm138.4,0h10.88V156H172.26Zm-.43,5.8h-16.7V138.77h-9.64m-99.7,12.12h16V138.77h9.1m112.3-51.11H172.26V76.73h10.88Zm-138.4,0H33.86V76.73H44.74Zm.43-5.79h16.7V94h8.44m100.9-12.11h-16V94h-9.1m30.56,17H187.6v10.93H176.72Zm-.42,5.8H146.67M38.83,122H28V111H38.83Zm.43-5.8H69.77m44.78,12.36h-6.72m-.38-12.76v24.78h9.71m3-37.17A12.32,12.32,0,1,1,107.83,91,12.36,12.36,0,0,1,120.15,103.36Zm2.1-25.71v-17c0-6.79-6.3-10.67-14-10.67s-14,3.88-14,10.67v17m41.36,1.16H80.87A9.92,9.92,0,0,0,71,88.72v54.05a9.93,9.93,0,0,0,9.86,9.92h54.75a9.93,9.93,0,0,0,9.86-9.92V88.72A9.92,9.92,0,0,0,135.62,78.81Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCybersecurity);
export default __webpack_public_path__ + "static/media/CYBERSECURITY.3f3aa886dc08fc00437f79dce8b0594f.svg";
export { ForwardRef as ReactComponent };